import './lib/trustedTypes.bootstrap';
import { createRoot, hydrateRoot } from 'react-dom/client';

import App from './App';
import { initializeCms } from './cms/content';
import { seedCachedProduct, type ShopifyProductFull } from './lib/productCache';



// Wyłącz natywne przywracanie pozycji scrolla przez przeglądarkę przy
// wstecz/naprzód — bez tego przeglądarka próbuje odtworzyć starą pozycję
// scrolla per wpis w historii, co konkuruje z własnym scrollTo(0,0) SPA
// (ScrollToTop w App.tsx) i przy nawigacji wstecz może wygrać wyścig,
// zostawiając stronę wylądowaną w środku zamiast na górze. Jeden globalny
// przełącznik — SPA odtąd w pełni kontroluje scroll przy każdej nawigacji.
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

const rootElement = document.getElementById('root')!;
initializeCms();
const productDataElement = document.getElementById('bukietowa-prerender-product');
const isHome = location.pathname.replace(/\/+$/, '') === import.meta.env.BASE_URL.replace(/\/+$/, '');
const homeData = isHome ? document.getElementById('bukietowa-home-shell') : null;
const homeTime = homeData ? Number(homeData.getAttribute('data-time')) : undefined;

if (productDataElement?.textContent) {
  try {
    seedCachedProduct(JSON.parse(productDataElement.textContent) as ShopifyProductFull);
  } catch {
    // An invalid cache seed must never prevent the storefront from loading.
  }
}

// Product snapshots carry their catalog payload; the homepage shell carries
// its render timestamp and public first-screen state. Full snapshots of other
// routes may include content deferred in a normal visitor session.
if ((productDataElement?.textContent || homeData) && rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <App initialTime={homeTime} />);
} else {
  createRoot(rootElement).render(<App />);
}

